import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { MerchCardShadowColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { useAppSelector } from '../../../../reducers';
import { isUngatedForInbound25Selector } from '../../../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCards = ({
  columns,
  children
}) => {
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(MerchCardShadowColumns, {
      columns: columns,
      isUngatedForInbound25: isUngatedForInbound25,
      children: children
    })
  });
};